module.exports = __webpack_public_path__ + "static/img/introduction-barometer-climate.d116a73.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/introduction-barometer-climate.jpg
// module id = tnry
// module chunks = 0